<template>
  <v-card id="add-quote">
    <v-card-title class="bg-primary text-white text-h6">New Quote</v-card-title>
    <v-card-text class="pt-6">
      <v-form ref="form" validate-on="blur">
        <v-select :items="Object.values(productData.regions)" v-model="form.region" label="Region"> </v-select>
        <v-text-field
          v-model="form.customerEmail"
          label="Customer Email"
          :rules="[$rules.required('email'), $rules.email('email')]"
          required
        >
        </v-text-field>
        <v-autocomplete
          v-model="form.customerType"
          :items="customerTypes"
          label="Customer Type"
          :rules="[$rules.required('customer type')]"
          required
        ></v-autocomplete>
        <v-text-field
          v-if="projectDetailsRequired"
          v-model="form.companyName"
          label="Company Name"
          :rules="[$rules.required('company name')]"
          required
        >
        </v-text-field>
        <v-text-field
          v-if="projectDetailsRequired"
          v-model="form.projectName"
          label="Project Name"
          :rules="[$rules.required('project name')]"
          required
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        variant="text"
        @click="
          () => {
            $refs.form.reset()
            $emit('cancel')
          }
        "
        >Cancel</v-btn
      >
      <v-btn variant="flat" color="accent" @click="validate" :disabled="submitting">Create</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import uid from 'uid'
import productData from '@/js/productData'
import { auth, db, functions } from '@/js/db'
import { collection, doc, setDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'

export default {
  name: 'QuoteAdd',
  data() {
    return {
      productData: productData,
      uid: uid,
      submitting: false,
      form: {
        creatorEmail: auth.currentUser.email,
        deadReason: null,
        region: 'uk',
        dateCreated: this.$utils.tsNow(),
        companyName: 'N/A',
        projectName: 'N/A',
        versions: [
          {
            id: null,
            creatorEmail: auth.currentUser.email,
            published: false,
            title: 'Version 1',
            date: this.$utils.tsNow(),
            fronts: [],
            coverPanels: [],
            spacerPanels: [],
            materials: [],
            urtils: [],
            pantries: [],
            handles: [],
            worktops: [],
            discount: 0,
            discountWorktops: 0,
            pricing: null,
            foc: false
          }
        ]
      },
      customerTypes: [
        { text: 'Home Owner', value: 'Home Owner', projectDetailsRequired: false },
        { text: 'Architect', value: 'Architect', projectDetailsRequired: true },
        { text: 'Interior Designer', value: 'Interior Designer', projectDetailsRequired: true },
        { text: 'Property Developer', value: 'Property Developer', projectDetailsRequired: true },
        { text: 'Contractor', value: 'Contractor', projectDetailsRequired: true }
      ]
    }
  },
  computed: {
    projectDetailsRequired() {
      if (!this.form.customerType) return false
      const selectedType = this.customerTypes.find((ct) => ct.value === this.form.customerType)
      return selectedType ? selectedType.projectDetailsRequired : false
    }
  },
  watch: {
    'form.customerType'(newVal) {
      const selectedType = this.customerTypes.find((ct) => ct.value === newVal)
      if (selectedType && !selectedType.projectDetailsRequired) {
        this.form.companyName = 'N/A'
        this.form.projectName = 'N/A'
      } else if (selectedType && selectedType.projectDetailsRequired) {
        // Clear the N/A values when switching to a customer type that requires details
        if (this.form.companyName === 'N/A') this.form.companyName = ''
        if (this.form.projectName === 'N/A') this.form.projectName = ''
      }
    }
  },
  methods: {
    async validate() {
      if (!(await this.$utils.validateForm(this.$refs.form))) return
      if (this.submitting) return
      this.submitting = true

      // set the default currency on the version
      this.form.versions[0].currency = productData.getDefaultCurrencyForRegion(this.form.region)
      this.form.versions[0].id = uid(10)

      try {
        const getExchangeRates = httpsCallable(functions, 'getExchangeRates')
        const fxResult = await getExchangeRates({ base: 'GBP', symbols: ['EUR', 'USD'] })
        this.form.versions[0].exchangeRates = fxResult.data
      } catch (e) {
        this.form.versions[0].exchangeRates = null
      }

      this.submit()
    },
    submit() {
      const quoteRef = doc(collection(db, 'quotes'))
      setDoc(quoteRef, this.form).then(() => {
        this.submitting = false
        this.$refs.form.reset()
        this.$emit('complete')
        this.$router.push({
          name: 'quoteEdit',
          params: { quoteID: quoteRef.id }
        })
      })
    }
  }
}
</script>
